import React from 'react';

const GridBackground: React.FC = () => {
  return <div className="grid-background" />;
};

export default GridBackground;
